import { actionTypes } from '../action/actionTypes';

const initialState = {
  buttonList: [], // Assuming buttonList is an array of button IDs or objects
  messages: '', // Assuming messages is a string, possibly the latest message
  type: '', // Assuming type is a string indicating some state or action type
  code: '',
  error: '',
};

export const powerBIRefreshReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.powerBIRefresh.TRIGGER_BUTTON_REQUEST:
      return {
        ...state,
        buttonList: action.payload.buttonList || state.buttonList, // Preserve existing if payload is undefined
        messages: action.payload.message || state.messages, // Preserve existing if payload is undefined
        type: action.payload.type || state.type,
      };
    case actionTypes.powerBIRefresh.TRIGGER_BUTTON_SUCCESS:
      return {
        ...state,
        buttonList: action.payload.buttonList || state.buttonList, // Preserve existing if payload is undefined
        messages: action.payload.message || state.messages, // Preserve existing if payload is undefined
        type: action.payload.type || state.type,
        code: action.payload,
        error: '',
      };
    case actionTypes.powerBIRefresh.TRIGGER_BUTTON_FAILURE:
      return {
        ...state,
        error: action.payload || 'Error occurred',
        type: 'error',
      };
    case actionTypes.powerBIRefresh.WEBSOCKET_MESSAGE_RECEIVED:
      // console.log(
      //   ' PBI store data websocketMessageReceived reducer- buttonId  :',
      //   action,
      // );
      return {
        ...state,
        buttonList: action.payload.buttonList,
        messages: action.payload.message,
        type: action.payload.type,
        error: '',
      };
    case actionTypes.powerBIRefresh.STATE_RESET:
      return {
        buttonList: [],
        messages: '',
        type: '',
        code: '',
        error: '',
      };
    default:
      return state;
  }
};

export default powerBIRefreshReducer;
